export default __webpack_public_path__ + "static/media/question.c8d774bf.svg";